import { Stack } from '@mui/material';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import * as React from 'react';
import { TailSpin } from 'react-loader-spinner';
import utils from 'src/assets/utils/utils';

function Row(props) {
  const { row } = props;

  // Action header/message only apply once a lead is Due / Paid / Complete.
  // For those, use the levelMeta entry at the lead's current level.
  const ACTION_STATUSES = ['due', 'paid', 'complete', 'completed'];
  const showAction = ACTION_STATUSES.includes((row?.status || '').toLowerCase());
  const currentMeta = showAction
    ? (row?.levelMeta || []).find((m) => m?.level === row?.currentLevel)
    : null;

  // Customer pincode can be stored under varying keys ("pincode",
  // "Area Pincode", "Pin Code", ...). Normalise separators before matching.
  const pincode =
    row?.parameters?.pincode ||
    (row?.parameters &&
      row.parameters[
        Object.keys(row.parameters).find((k) =>
          k
            .toLowerCase()
            .replace(/[\s_-]/g, '')
            .includes('pincode'),
        )
      ]) ||
    '';

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell align="left">{utils.formatTimestamp(row?.createdAt)}</TableCell>
        <TableCell align="left">{utils.formatTimestamp(row?.last_updated_date)}</TableCell>
        <TableCell align="left">
          {<h4>{row?._id}</h4>}
          <br />
          {row?.sub_lead_id && <span>Sub Lead Id: {row?.sub_lead_id}</span>}
        </TableCell>
        <TableCell align="left">
          <h4>{row?.user_id && row?.user_id?.user_id}</h4>
          <br />

          {row?.user_id && row?.user_id?.name}
        </TableCell>
        <TableCell align="center" size={'small'}>
          {row?.total_conversion}
        </TableCell>
        <TableCell align="center" size={'small'}>
          {row?.clicked.length}
        </TableCell>
        <TableCell align="left">
          <h4>{row?.product_id && row?.product_id?.title}</h4>

          <br />
          <p>{row?.product_id && row?.product_id?.status}</p>
          <p>{row?.earntype}</p>
          {/* Publisher is sent by the API only to super_admins or users with
              view_reports / create_reports perms; absent otherwise. */}
          {row?.product_id?.publisher && <p>Publisher: {row?.product_id?.publisher}</p>}
        </TableCell>

        <TableCell align="left" size="medium">
          <h4>Name: {row?.parameters?.name || row?.parameters?.Name}</h4>
          <br />
          Number: {row?.parameters?.Number || row?.parameters?.number}
          <br />
          Pincode: {pincode}
        </TableCell>
        <TableCell align="left" size="medium">
          {currentMeta ? (
            <>
              <h4>Action Header: {currentMeta?.action_header || row?.action_header || '-'}</h4>
              <h4>Title: {currentMeta?.title}</h4>
              <p>level: {currentMeta?.level}</p>
              <p>amount: {currentMeta?.amount}</p>
            </>
          ) : (
            '-'
          )}
        </TableCell>
        <TableCell align="left" size="medium">
          {currentMeta ? (
            <>
              <h4>Title: {currentMeta?.title}</h4>
              <p>{currentMeta?.description}</p>
            </>
          ) : (
            '-'
          )}
        </TableCell>

        <TableCell align="left">{row?.status}</TableCell>
        <TableCell align="center" width={'7px'} p={'5px'}>
          {row?.due_payment}
        </TableCell>
        <TableCell align="center" width={'7px'} p={'5px'}>
          {row?.paid}
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default function LeadsHistory({ details, loaded }) {
  console.log({ details });
  return (
    <>
      {loaded ? (
        <Stack justifyContent="center" alignItems="center" sx={{ width: '75vw', height: '55vh' }}>
          <TailSpin height={45} width={45} style={{ margin: 'auto', background: '#444' }} />
        </Stack>
      ) : (
        <TableContainer component={Paper} sx={{ maxHeight: '70vh' }}>
          <Table aria-label="collapsible table" stickyHeader>
            <TableHead>
              <TableRow sx={{ fontWeight: 800 }}>
                <TableCell align="left">Created Date</TableCell>
                <TableCell align="left">Updated Date</TableCell>
                <TableCell align="left">Lead Id</TableCell>
                <TableCell align="left">UserId</TableCell>
                <TableCell align="left">Conversions</TableCell>
                <TableCell align="left">Clicked</TableCell>
                <TableCell align="left">Campaign</TableCell>
                <TableCell align="left">Parameters</TableCell>
                <TableCell align="left">Action Header</TableCell>
                <TableCell align="left">Action Message</TableCell>

                <TableCell align="left">Lead Status</TableCell>
                <TableCell align="left">Due</TableCell>
                <TableCell align="left">Paid</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {details && details.length > 0
                ? details.map((row) => <Row key={row.id} row={row} />)
                : null}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
}
